// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;

export const BASEURL = `https://pos-api.qfxcinemas.com`;
export const SOCKETURL = `https://socket-api.qfxcinemas.com`;
// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://d1t5b7sh1v2g3w.cloudfront.net/`;
export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;



// WEBPACK FOOTER //
// ./src/config/index.js